// src/components/seo/hreflang.tsx
import { useLocation } from 'react-router-dom';

export const useHreflangTags = (locale: string) => {
    const location = useLocation();
    const currentPath = location.pathname;
    const baseUrl = window.location.origin;

    const getLocalizedUrl = (lang: string) => {
        let localizedPath = currentPath;

        if (lang === 'en') {
            localizedPath = currentPath.replace(/^\/(cn|tw|es|fr)/, '/en');
        } else if (lang === 'zh-Hans') {
            localizedPath = currentPath.replace(/^\/(en|tw|es|fr)/, '/cn');
        } else if (lang === 'zh-Hant') {
            localizedPath = currentPath.replace(/^\/(en|cn|es|fr)/, '/tw');
        } else if (lang === 'es') {
            localizedPath = currentPath.replace(/^\/(en|cn|tw|fr)/, '/es');
        } else if (lang === 'fr') {
            localizedPath = currentPath.replace(/^\/(en|cn|tw|es)/, '/fr');
        }

        return `${baseUrl}${localizedPath}`;
    };

    const generateHreflangTags = () => {
        // const languages = ['en', 'cn', 'tw', 'es', 'fr'];
        const languages = ['en', 'zh-Hans', 'zh-Hant', 'es', 'fr'];
        const tags = languages.map((lang) => ({
            rel: 'alternate',
            hreflang: lang,
            href: getLocalizedUrl(lang),
        }));

        tags.push({
            rel: 'alternate',
            hreflang: 'x-default',
            href: getLocalizedUrl('en'),
        });

        return tags;
    };

    const updateHreflangTags = () => {
        const head = document.head;
        const existingTags = document.querySelectorAll('link[rel="alternate"][hreflang]');
        existingTags.forEach((tag) => head.removeChild(tag));

        generateHreflangTags().forEach((tag) => {
            const link = document.createElement('link');
            link.rel = tag.rel;
            link.hreflang = tag.hreflang;
            link.href = tag.href;
            head.appendChild(link);
        });
    };

    

    return { updateHreflangTags };
};